import { REQUIRED_FIELDS } from "../actions/requiredAction";

const initialState = {
  fields: [],
};

const requiredReducer = (state = initialState, action) => {
  if(action.type === REQUIRED_FIELDS){
    return {
        ...state,
        fields: action.payload,
      };
  } else{
    return state
  }
};

export default requiredReducer;
